import {CREDIT_CARD_TYPES, RECEIVABLE_TYPES} from './receivableTypes';

export const imageMapping = {
  [CREDIT_CARD_TYPES.AMERICAN_EXPRESS]: 'Amex',
  [CREDIT_CARD_TYPES.VISA]: 'Visa',
  [CREDIT_CARD_TYPES.MASTER_CARD]: 'MasterCard',
  [RECEIVABLE_TYPES.PAYPAL]: 'Paypal',
  [RECEIVABLE_TYPES.BTPAYPAL]: 'Paypal',
  [RECEIVABLE_TYPES.BTAPPLEPAY]: 'ApplePay',
  [RECEIVABLE_TYPES.BTGOOGLEPAY]: 'GooglePayMark',
};
